const zh = {
    next: '下一步',
    error: '错误',
    notFound: '404 Not found.',
    m: {
        loginTitle: "解锁您的充电宝",
        phonePlaceholder: "手机号码",
        or: '或',
        emailLogin: '使用邮箱继续',
        phoneLogin: '使用手机号继续',
        quickLogin: '以游客身份继续',
        loginRequiredTip: '请先登录',
        continueGoogle: "通过 Google 继续",
        continueApple: "通过 Apple 继续",
        langBoxTitle: "选择语言",
        policyAndTerms: "同意[brandName]的<a href='[termsOfServiceUrl]'>服务条款</a>和<a href='[privacyPolicyUrl]'>隐私政策</a>。",
        verifyTitle: '输入发送到[phonenumber]的6位数验证码',
        verifyEmailTitle: '输入发送到[email]的6位数验证码',
        paymentTitle: '解锁您的充电宝',
        resend: "重新发送验证码",
        emailAddress: "电子邮件地址",
        registerTitle: '输入您的信息',
        fNameInput: '名字',
        lNameInput: '姓氏',
        emailInput: '电子邮件地址',
        birthInput: '出生日期',
        postCodeInput: '邮政编码',
        billingRate: '费用',
        unpaidPopupSubtitle: "您有未支付的订单",
        unpaidPopupContent: "您有一笔未支付的订单。请在再次租赁之前先结清款项。",
        payNow: "立即支付",
        add: "添加",
        minBalanceTag: '最低：{amount}',
        paymentSuccessfulSubtitle: "付款成功！",
        paymentSuccessfulContent: "您现在可以继续租借了！",
        goToRental: "前往租借",
        repaymentTitle: "订单支付",
        rentalInformation: "租借信息",
        selectPayMethod: '选择支付方式',
        selectAuthorizationMethod: '选择授权方式',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: '余额',
        creditOrDebit: '信用卡或借记卡',
        free: '免费',
        pay: '支付',
        confirm: '确认',
        cancel: '取消',
        unlockNow: '解锁充电宝',
        savePay: '保存卡并支付',
        saveRent: '租借',
        recharge: '充值',
        balancePopupTitle: '充值',
        balancePopupCurrentBalance: '当前余额：{amount}',
        balancePopupMinRentBalance: '最低可租借余额：{amount}',
        topUpRent: '充值',
        topUpSaveCard: '充值',
        bindPopupTitle: '添加支付卡',
        cardPaymentTitle: '卡支付',
        preparingTitle: '正在准备您的充电宝',
        preparingSubtitle: '您的充电宝正在弹出。请耐心等待。',
        preparingStationBusySubtitle: '正在等待设备完成上一笔弹出，请稍候。',
        rentalSuccessTitle: '成功 !',
        rentalFailTitle: '失败 !',
        rentalSuccessSubtitle: '感谢您使用[brandName]。使用完毕后请归还充电宝。',
        rentalNumber: '订单编号',
        rentalTime: '租借时间',
        rentalLocation: '租借地点',
        returnTime: "归还时间",
        returnLocation: "归还地点",
        rentalDuration: "租借时长",
        totalAmount: "总金额",
        paidAmount: "已支付金额",
        unpaidAmount: "待支付金额",
        currentFee: "预计费用",
        rentalInfo: '租借信息',
        rentingTitle: '您正在使用[brandName]充电宝',
        keepIt: '想留下它？立即购买！',
        findNearby: '轻松查找附近的归还点——立即下载我们的应用！',
        nearbyStationTitle: '附近借还点',
        nearbyStationSearchPlaceholder: '搜索附近充电站',
        nearbyStationRent: '租借',
        nearbyStationReturn: '归还',
        nearbyStationAvailable: '可借',
        nearbyStationEmpty: '可还',
        nearbyStationLoading: '正在加载附近机器...',
        nearbyStationNoStations: '附近无机器',
        nearbyStationNoRentStations: '附近无可租借的机器',
        nearbyStationNoReturnStations: '附近无可归还的机器',
        nearbyStationSearchAria: '搜索附近机器',
        nearbyStationType: '机器类型',
        nearbyStationDistance: '距离',
        scanForPowerbank: '扫码租借充电宝',
        scanOtherMachine: '扫描其他机器',
        findNearbyReturnableMachines: '找可还机器',
        scannedMachine: '已扫描机器',
        scannedMachineWithCode: '已扫描机器 {code}',
        loginViewNearbyRentableMachines: '查看附近其他机器',
        viewNearbyReturnLocations: '找可还机器',
        currentMachineUnavailableHint: '当前机器不可租借',
        currentMachineAvailableHint: '当前机器可租借',
        currentMachineMapDetail: '您已扫描机器 {code}。点击这里可返回并继续使用这台机器租借。',
        currentMachineMapAction: '点击继续使用这台机器租借。',
        machineUnavailableMapDetail: '您已扫描机器 {code}，但当前不可使用。原因：{reason}。请扫描其他机器，或在地图上查看附近机器。',
        machineUnavailableMapAction: '可查找附近可用机器，并扫描其机器码。',
        mapIslandMachineUnavailableShort: '当前机器不可租借',
        mapIslandMachineAvailableActionShort: '继续使用当前机器',
        mapIslandMachineUnavailableActionShort: '扫描附近其他机器',
        mapIslandReturnActionShort: '返回租借页',
        rentingMapIslandTitle: '租借中',
        tapToReturnRentalPage: '点击返回租借页。',
        scan: '扫码',
        scannerHint: '请扫描充电站上的二维码',
        flashlight: '手电筒',
        mapBack: '返回',
        currentLocation: '当前位置',
        backToMap: '返回地图',
        mapMenu: '菜单',
        mapMenuYourInfo: '个人资料',
        mapMenuLanguage: '语言',
        mapMenuHelp: '帮助',
        helpTitle: '帮助',
        helpReportProblem: '问题反馈',
        helpChatWithUs: '联系我们',
        chatWithUsTitle: '联系我们',
        chatContactMethods: '联系方式',
        reportProblemTitle: '问题反馈',
        reportDeviceCode: '设备编码',
        reportScanQrCode: '扫描机器二维码',
        reportDeviceCodePlaceholder: '扫描机器二维码或输入机器ID',
        reportProblemType: '问题类型',
        reportProblemTypeAria: '问题类型',
        reportProblemPowerBankNotEjected: '设备未弹出充电宝',
        reportProblemCannotChargeDevice: '充电宝无法充电',
        reportProblemOrderNotEnded: '归还后订单未结束',
        reportProblemCableDamagedLost: '充电线损坏或丢失',
        reportProblemOther: '其他',
        reportTakePicture: '上传图片',
        reportChooseOrTakePicture: '上传图片',
        reportRemovePicture: '移除照片',
        reportDescribeProblem: '描述问题',
        reportDescriptionPlaceholder: '请输入问题描述',
        reportFieldRequired: '必填',
        reportFieldOptional: '选填',
        reportSubmit: '提交',
        reportSubmittedSuccessfully: '提交成功',
        mapMenuLogin: '登录',
        mapMenuLogout: '退出登录',
        mapMenuLogoutSuccess: '已退出登录',
        mapMenuLoadingProfile: '正在加载个人信息...',
        mapMenuLogoutConfirmTitle: '确认退出登录？',
        mapMenuLogoutConfirmContent: '退出后，再次租借前需要重新登录。',
        profileTitle: '个人资料',
        profileSave: '保存',
        profileNoChanges: '请至少修改一项且保留有效内容。',
        profileDeleteAccount: '删除',
        profileDeleteConfirmTitle: '删除账号？',
        profileDeleteConfirmContent: '您账号中的所有数据都将被永久清除，并且删除后您将退出登录。',
        closeScanner: '关闭扫码',
        directions: '导航',
        call: '拨打电话',
        cabinet: '机器',
        addressUnavailable: '地址不可用',
        open: '营业中',
        closed: '已关闭',
        opens: '开始营业',
        closes: '停止营业',
        hoursUnavailable: '营业时间不可用',
        mapUnavailable: '地图不可用',
        googleMapsKeyNotConfigured: 'Google Maps key 未配置',
        googleMapsLoadFailed: 'Google Maps 加载失败',
        retry: '重试',
        mapLoading: '地图加载中...',
        mapReloading: '正在重新加载地图...',
        cameraUnavailable: '当前浏览器不支持摄像头',
        cameraPermissionDenied: '摄像头权限已被拒绝',
        cameraStartFailed: '摄像头启动失败',
        flashlightUnsupported: '当前设备不支持手电筒',
        flashlightSwitchFailed: '手电筒切换失败',
        invalidQrCode: '二维码格式无效',
        noon: '中午',
        weekdayMonday: '星期一',
        weekdayTuesday: '星期二',
        weekdayWednesday: '星期三',
        weekdayThursday: '星期四',
        weekdayFriday: '星期五',
        weekdaySaturday: '星期六',
        weekdaySunday: '星期日',
        weekdayMon: '周一',
        weekdayTue: '周二',
        weekdayWed: '周三',
        weekdayThu: '周四',
        weekdayFri: '周五',
        weekdaySat: '周六',
        weekdaySun: '周日',
        orderDeatil: '订单详情',

        subsTitle: '订阅计划',
        default: '默认',
        subscribeAndSave: '订阅并保存',
        autoRenew: '自动续费',
        reachLimit: '使用已达上限',
        paymentAuthorizationTitle: '支付授权',
        paymentAuthorizationRequired: '需要支付授权',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: '如果本次租借可能超出您的套餐范围，或尚未绑定可用于额外费用扣款的支付方式，则需要进行授权。',
        paymentAuthorizationDesc3: '将会预授权冻结 [amount]。如无额外费用，归还后将全额退还；如产生额外费用，则在扣除相应费用后退还剩余金额。',
        paymentAuthorizationDesc4: '请选择以下任一种授权方式用于本次租借。',

        totalCost: '费用',
        returnSuccessTitle: '归还成功！',
        returnSuccessSubtitle: '感谢您使用[brandName]',
        rentAgain: '再次租借',
        guestLoginTips: '该功能需要登录正式账号，游客模式不可用，是否去登录？',
        stationNotFoundTitle: "未找到站点",
        stationNotFound: "请尝试重新扫码。",
        stationNotSetUpTitle: "站点未设置",
        stationNotSetUp: "请联系管理员寻求帮助，或检查附近的其他站点。",
        stationOfflineTitle: "站点离线",
        stationOffline: "请检查电源线是否连接正常，或尝试重新插拔。",
        stationBusyTitle: "站点繁忙",
        stationBusy: "站点当前正在处理租借任务。请稍候再试。",
        powerBanksUnavailableTitle: "充电宝不可用",
        powerBanksUnavailable: "由于技术问题，充电宝暂时不可用。请稍后再试或检查附近的其他站点。",
        noPowerBanksAvailableTitle: "无可用充电宝",
        noPowerBanksAvailable: "请检查附近的其他站点。",
        serverErrorTitle: "服务器错误",
        serverError: "请稍后再试，或联系管理员寻求帮助。",
    },
    tMsg: {
        agreePolicy: '请先阅读并同意[brandName]的隐私协议和条款',
        errorTel: '请输入正确的手机号',
        sendSuccess: '发送成功',
        inputAll: '请输入所有必填信息',
        wrongEmail: '邮箱格式不正确',
        wrongBirthday: '生日格式不正确',
        initPayFail: '支付初始化失败',
        bindTimeout: '绑卡超时，请重试',
        bindSuccess: '绑卡成功',
        subscriptionSuccess: '订阅成功',
        bindFailed: '绑卡失败',
        paymentFailed: '支付失败',
        loginError: '登录失败',
        paymentMethodNotSupported: '不支持的支付方式',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time]分钟',
        freeTimeDesc: '前[free_time]分钟免费',
        flatFeeDesc: '前[flat_fee_time]分钟[flat_fee]',
        lowLimitDesc: '最低收费: [low_limit]',
        topLimitDesc: '每24小时最高收费: [top_limit]',
        preAuthDesc: '预授权[pre_auth_amount]',
        depositDesc: '如果未在[maximum_rental_time]小时内归还，将收取[deposit]，此时充电宝将归您所有',
        ruleError: '规则错误',
        noneRuleDesc: '无规则',
        taxIncluded: '已含税',
        taxIncludedWithRate: '已含[tax]%税费'
    },
    subscriptionType: {
        1: '每个订阅周期免费[value]分钟',
        2: '每月免费[value]分钟',
        3: '每周免费[value]分钟',
        4: '每日免费[value]分钟',
        6: '每个订阅周期免费[value]次',
        7: '每月免费[value]次',
        8: '每周免费[value]次',
        9: '每日免费[value]次',
        unlimited: '无限制',
        unlimitedRentals: '每个订阅周期免费无限制租赁',
        durationLimit: '每次租赁最多[limit]分钟免费租赁。之后每[price_time]分钟[price]',
        maxLimit: '，每日最多[top_limit]',
    },
    subscriptionTitleType: {
        1: '每个订阅周期[value]分钟',
        2: '每月[value]分钟',
        3: '每周[value]分钟',
        4: '每日[value]分钟',
        6: '每个订阅周期[value]次',
        7: '每月[value]次',
        8: '每周[value]次',
        9: '每日[value]次',
        unlimited: '无限制',
        unlimitedRentals: '每个订阅周期无限制租赁',
    },
    subscriptionInfo: {
        period: '有效期：[start] - [end]',
        usedShort: '（[used]/[total] 已用）',
        usage: '使用次数：共 [total] 次，已用 [used] 次，剩余 [remaining] 次',
        usageUnlimited: '使用次数：无限制',
        autoRenew: '自动续订：[value]',
        autoRenewTrue: '是',
        autoRenewFalse: '否',
    },
    time: {
        day: '天',
        hour: '小时',
        minute: '分钟',
        second: '秒',
        month: '月',
        year: '年'
    },
    eMsg: {
        30001: '人机验证失败',
        500: "网络错误",
        1000: "操作失败",
        30022: "手机号格式不正确",
        30128: "获取验证码次数过多，请稍后重试",
        30129: "发送验证码失败",
        //
        30101: '验证码已过期或不正确',
        // 租借
        50101: "机器不存在",
        50105: "你有正在租借中的订单",
        50106: "机器不在线",
        50108: "机器没有可供租借的充电宝",
        50109: "弹出充电宝失败",
        50113: '该网点需要登录账号使用',
        50114: '游客暂不支持该功能，请登录账号',
        50111: '绑定的信用卡效',
        50305: '绑定的信用卡效',
        80411: '绑卡失败',
    }
}
export default zh

/*
请先阅读并同意隐私协议和条款
请输入所有必填信息
30022 手机号格式不对
30128 获取验证码次数太多
30129 发送验证码失败
30101 验证码不对或已失效
不正确的生日格式
80411 绑定银行卡失败

50106 station offline
50108 机柜内没有可租借的充电宝
50109 弹出电池失败
 */
